import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type SchoolsSchoolClassQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type SchoolsSchoolClassQuery = { __typename?: 'Query', schoolsSchoolClass?: { __typename?: 'schoolsSchoolClass', name: string, year?: { __typename?: 'schoolsSchoolYear', name: string } | null | undefined, school?: { __typename?: 'schoolsSchool', name: string } | null | undefined, tags: Array<{ __typename?: 'schoolsSchoolTag', id: string, tag: string }> } | null | undefined };


export const SchoolsSchoolClassDocument = gql`
    query SchoolsSchoolClass($id: ID) {
  schoolsSchoolClass(id: $id) {
    name
    year {
      name
    }
    school {
      name
    }
    tags {
      id
      tag
    }
  }
}
    `;

/**
 * __useSchoolsSchoolClassQuery__
 *
 * To run a query within a React component, call `useSchoolsSchoolClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolsSchoolClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolsSchoolClassQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSchoolsSchoolClassQuery(baseOptions?: Apollo.QueryHookOptions<SchoolsSchoolClassQuery, SchoolsSchoolClassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolsSchoolClassQuery, SchoolsSchoolClassQueryVariables>(SchoolsSchoolClassDocument, options);
      }
export function useSchoolsSchoolClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolsSchoolClassQuery, SchoolsSchoolClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolsSchoolClassQuery, SchoolsSchoolClassQueryVariables>(SchoolsSchoolClassDocument, options);
        }
export type SchoolsSchoolClassQueryHookResult = ReturnType<typeof useSchoolsSchoolClassQuery>;
export type SchoolsSchoolClassLazyQueryHookResult = ReturnType<typeof useSchoolsSchoolClassLazyQuery>;
export type SchoolsSchoolClassQueryResult = Apollo.QueryResult<SchoolsSchoolClassQuery, SchoolsSchoolClassQueryVariables>;